module.exports = __webpack_public_path__ + "img/Plus_White.8a1c8359.svg";